import { connect } from 'react-redux';
import {
  fetchTagsData,
  generateUrl,
  resetMagazineURL
} from '../../redux/actions/mediaActions';
import { change } from 'redux-form';
import { fetchApps } from '../../redux/actions/appActions';
import PickedMagazineForm from './PickedMagazineForm';

const mapStateToProps = ({
  apps,
  media: { loading, data, url, categories = [], UnitedState },
  form: { PickedMagazineForm = {} }
}) => {
  const { app, autoLocale } = PickedMagazineForm.values || {};
  return {
    formValues: { app, autoLocale },
    apps: apps.sortedList,
    UnitedState,
    loading,
    categories,
    data,
    url: PickedMagazineForm.submitSucceeded && url,
    appsLoading: apps.loading
  };
};

const mapDispatchToProps = dispatch => ({
  fetchTagsData: ({ key, publisherId }) =>
    dispatch(fetchTagsData(key, publisherId)),
  fetchAllApps: () => dispatch(fetchApps()),
  resetURL: () => dispatch(resetMagazineURL()),
  changeFieldValue: (field, value) =>
    dispatch(change('PickedMagazineForm', field, value)),
  onSubmit: data => dispatch(generateUrl(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PickedMagazineForm);



// WEBPACK FOOTER //
// ./src/components/pickedMagazine/PickedMagazineContainer.js